// 根据菜单项路径,返回菜单项
export const getMenuItemByPath = (path, menu) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].path === path) {
      return menu[i]
    } else {
      let menuItem = null
      if (menu[i].children.length > 0) {
        menuItem = this.getMenuItemByPath(path, menu[i].children)
        if (menuItem) {
          return menuItem
        }
      }
    }
  }
  return null
}

// 根据父菜单项id,返回子菜单项数组（数组不包含父菜单项，parentId允许为0）
export const searchChildMenuItemListByParentId = (parentId, descendantRequired, menu) => {
  if (!descendantRequired) {
    return menu.filter(item => {
      return item.parentId === parentId
    })
  } else {
    let descendantMenuItems = []
    _searchDescendantMenuItemList(parentId, menu, descendantMenuItems)
    return descendantMenuItems
  }
}

// 根据父菜单项路径,返回子菜单项数组
export const searchChildMenuItemListByParentPath = (parentPath, descendantRequired, menu) => {
  if (!descendantRequired) {
    return menu.filter(item => {
      return item.path === parentPath
    })
  } else {
    let parentMenuItem = menu.find(item => {
      return item.path === parentPath
    })

    if (!parentMenuItem) {
      return []
    }

    let descendantMenuItems = []
    _searchDescendantMenuItemList(parentMenuItem.id, menu, descendantMenuItems)
    return descendantMenuItems
  }
}

// 根据父菜单项id,返回子孙菜单项数组（数组不包含父菜单项，parentId允许为0）
const _searchDescendantMenuItemList = (parentId, menu, descendantMenuItems) => {
  let descendantMenuItems2 = menu.filter(item => {
    return item.parentId === parentId
  })
  descendantMenuItems.concat(descendantMenuItems2)

  for (let i = 0; i < descendantMenuItems2.length; i++) {
    _searchDescendantMenuItemList(descendantMenuItems2[i].id, menu, descendantMenuItems)
  }
  return descendantMenuItems
}

// 根据父菜单项id,返回菜单（树顶层节点为父菜单项，parentId允许为0）
export const loadMenuByParentId = (parentId, menu) => {
  let parentMenuItem = menu.find(item => {
    return item.parentId === parentId
  })

  if (!parentMenuItem) {
    return []
  }

  let parentMenuItem2 = {
    id: parentMenuItem.id,
    key: parentMenuItem.path.length && parentMenuItem.path[0] === '/' ? parentMenuItem.path.slice(1) : parentMenuItem.path,
    query: parentMenuItem.query,
    value: parentMenuItem.name,
    icon: parentMenuItem.icon,
    children: []
  }
  return loadMenu(parentMenuItem2, menu)
}

// 根据父菜单路径,返回菜单
export const loadMenuByParentPath = (parentPath, menu) => {
  let parentMenuItem = menu.find(item => {
    return item.path === parentPath
  })

  if (!parentMenuItem) {
    return null
  }

  let parentMenuItem2 = {
    id: parentMenuItem.id,
    key: parentMenuItem.path.length && parentMenuItem.path[0] === '/' ? parentMenuItem.path.slice(1) : parentMenuItem.path,
    query: parentMenuItem.query,
    value: parentMenuItem.name,
    icon: parentMenuItem.icon,
    children: []
  }
  return loadMenu(parentMenuItem2, menu)
}

// 加载菜单
const loadMenu = (parentMenuItem, menu) => {
  let descendantMenuItems = menu.filter(item => {
    return item.parentId === parentMenuItem.id
  })

  parentMenuItem.children = []
  descendantMenuItems.forEach(item => {
    parentMenuItem.children.push({
      id: item.id,
      key: item.path.length && item.path[0] === '/' ? item.path.slice(1) : item.path,
      query: item.query,
      value: item.name,
      icon: item.icon,
      children: []
    })
  })

  for (let i = 0; i < parentMenuItem.children.length; i++) {
    loadMenu(parentMenuItem.children[i], menu)
  }
  return parentMenuItem
}



// WEBPACK FOOTER //
// ./src/utils/menu.js